module.exports = __webpack_public_path__ + "img/icon-ai_supporter.2dbed4e3.svg";